"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Global_1 = require("./styles/Global");
const AnimWrap_1 = require("./styles/AnimWrap");
const Scene_1 = require("./styles/Scene");
const Face_1 = __importDefault(require("./Face"));
function default_1(props) {
    let { anim1, anim2, width = 5, height = 5, depth = 5, global = {}, faces, perspective, perspectiveOrigin, zIndex, } = props;
    // process config
    const buildFace = (face) => {
        const details = {
            width,
            height,
            depth,
            face,
            global,
        };
        return react_1.default.createElement(Face_1.default, Object.assign({}, details, { key: face.name }));
    };
    return (react_1.default.createElement(Scene_1.SceneStyle, { width: width, height: height, perspective: perspective, perspectiveOrigin: perspectiveOrigin, zIndex: zIndex },
        react_1.default.createElement(AnimWrap_1.AnimWrap, { animSpecs: anim1 },
            react_1.default.createElement(AnimWrap_1.AnimWrap, { animSpecs: anim2 },
                react_1.default.createElement(Global_1.ObjWrapper, null, faces && faces[0]
                    ? faces.map((face) => (face.name ? buildFace(face) : null))
                    : null)))));
}
exports.default = default_1;
